import React from 'react';
import styled from 'styled-components';

export const Wrap = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100px;
  height: 100px;
  background-color: #000;
  margin: -50px 0 0 -50px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 1000;
`;

export const Image = styled.img`
  display: block;
  margin-bottom: 10px;
`;

export const Text = styled.div`
  text-transform: uppercase;
  font-size: 12px;
  color: white;
`;
